import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import { useState } from 'react';

const useGetPrintPreferences = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [loading, setLoading] = useState(false);
  const [printPreferences, setPrintPreferences] = useState({});

  const getPrintPreferences = ({ packGuid }) => {
    setLoading(true);
    axiosClient
      .get(`Product/Branch/Packaging/Print/Preferences?GUID=${packGuid}`)
      .then(res => {
        if (res.status === 200) {
          setPrintPreferences(res.data?.value);
        } else {
          enqueueSnackbar(res?.message, { variant: 'error' });
        }
      })
      .catch(err => {
        enqueueSnackbar(err?.message, { variant: 'error' });
      })
      .finally(() => setLoading(false));
  };
  return [getPrintPreferences, loading, printPreferences];
};

export default useGetPrintPreferences;
